import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ApiResourceLocation,
  ConnectionHttpService,
  ResponseResult,
} from '@softline/core';
import { firstValueFrom } from 'rxjs';
import { SOFTLINE_API_WWS_WARENUEBERNAHME_LAGERPLATZ_AUSWAHL } from '../warenuebernahme.api';
import { Lagerplatz } from '@softapps/lager/core';

@Injectable()
export class LagerplatzService {
  private readonly httpService = inject(ConnectionHttpService);
  private readonly dataAccess = inject(ApiDataAccess);

  async loadLagerplatzAuswahl(idwu: string): Promise<Lagerplatz[]> {
    const location = {
      path: SOFTLINE_API_WWS_WARENUEBERNAHME_LAGERPLATZ_AUSWAHL,
      pathParams: {
        idwu,
      },
    } as ApiResourceLocation;

    return (await firstValueFrom(this.httpService.get<Lagerplatz[]>(location)))['result'];
  }

  async loadLagerplaetzeForProduct(
    id: number,
    queryParams?: { idlagerstamm?: string | number; idarteh?: number }
  ): Promise<any[]> {
    return (
      (
        await this.dataAccess.get<ResponseResult<any[]>>({
          path: 'v1/lagerplatz/artikelid-suche/{{id}}',
          pathParams: {
            id,
          },
          queryParams: queryParams ? queryParams : {},
        })
      )?.result ?? []
    );
  }
}
